<div
  [ngClass]="displayClass"
  (click)="linkClick()">
  {{ value | stripHtml }}
</div>
